import { render, staticRenderFns } from "./updateBus.vue?vue&type=template&id=ecc86cd2&scoped=true&"
import script from "./updateBus.vue?vue&type=script&lang=js&"
export * from "./updateBus.vue?vue&type=script&lang=js&"
import style0 from "./updateBus.vue?vue&type=style&index=0&id=ecc86cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc86cd2",
  null
  
)

export default component.exports